export { default } from "./RuleAdd";
